import React, {PropTypes} from 'react';
import {reduxForm} from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';
import Input from '../../../form/Input';
import {SelectIcon} from './SelectIcon';
import {validateRedux} from '../../../../utilites/validate';
import {FullPageDialog} from '../../../common/FullPageDialog';

class HeaderOneEditFormComponent extends React.Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired
  };

  render() {
    const {
      fields: {
        label,
        icon
      },
      onClose,
      handleSubmit
    } = this.props;

    return (
      <form noValidate onSubmit={handleSubmit}>
        <FullPageDialog label="Create New Tab" onClose={onClose} style={{overflow: 'auto'}}>
          <SelectIcon {...icon}/>
          <Input label="Add Tab Name" {...label} style={{display: 'inline-block'}} errorLabelStyle={{position: 'absolute'}}/>
          <RaisedButton label="Done" secondary type="submit"/>
        </FullPageDialog>
      </form>
    );
  }
}

const validate = (data) => {
  const validateConfig = {
    label: {presence:true},
    icon: {presence:true}
  };

  return validateRedux(data, validateConfig);
};

export const HeaderOneEditForm = reduxForm({
  form: '@club-cms/edit-header-one',
  fields: ['label', 'icon'],
  validate
})(HeaderOneEditFormComponent);


export default HeaderOneEditForm;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/HeaderOne/HeaderOneEditForm.js